import { validators } from "../../../validators/validators";

import style from "../../../sass/components/popups/create-shipment-popup.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { interpretEmailError, interpretReceiverAddressError } from "../../../validators/interpretators";
import PhoneInput from "react-phone-input-2";
import { selectCountries } from "../../citySelect/selectCitySlice";
import { Button } from "@mui/material";
import ReceiversList from "./ReceiversList";
import { createSavedReceiver, selectCreatingSavedReceiverError, selectCreatingSavedReceiverStatus, setCreatingSavedReceiverError, setCreatingSavedReceiverStatus } from "../shipmentsSlice";
import { pushAlert } from "../../alerts/alertSlice";
import { useTranslation } from "react-i18next";
import { validateReceiver } from "../../../validators/validateReceiver";
import { isB2BPackage, isDocumentsPackage } from "../../../helpers/packageTypesHelper/packageTypesHelper";
import SelectReceiverCity from "./Inputs/SelectReceiverCity";

const FirstPage = ({
    state,
    setState,
    errors,
    setErrors,
    currentPage,
    ownPage
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const receiverGeoFromSelector = useSelector(
        (state) => state.shipments.createShipmentPopup.receiverGeolocation
    );
    const creatingSavedReceiverStatus = useSelector(selectCreatingSavedReceiverStatus);
    const creatingSavedReceiverError = useSelector(selectCreatingSavedReceiverError)

    const [isChoosingFromSaved, setIsChoosingFromSaved] = useState(false);
    const [choosedFromState, setChoosedFromSaved] = useState(false);

    const [haveSavedCurrentReceiver, setHaveSavedCurrentReceiver] = useState(false);

    const [receiverGeoForChooseReceiver, setReceiverGeoForChooseReceiver] = useState(null);

    useEffect( () => {
        if(ownPage !== currentPage) {
            setIsChoosingFromSaved(false);
        }
    }, [currentPage, ownPage])

    //finding receiver city stuff
    const countries = useSelector(selectCountries);

    const [receiverGeolocation, setReceiverGeolocation] = useState({
        country: "Россия",
        city: "",
        area: "",
        district: "",
    });

    useEffect(() => {
        if (receiverGeolocation.country) {
            let hasCities = false;

            const country = countries.find(
                (country) => country["ru-name"] === receiverGeolocation.country || 
                country["tr-name"] === receiverGeolocation.country
            );

            if (country) {
                hasCities = country["has-cities"];
            }
            setState(prev => ({
                ...prev,
                "receiver-country": receiverGeolocation.country,
                "receiver-city": receiverGeolocation.city,
                "receiver-district": receiverGeolocation.district,
                "receiver-area": receiverGeolocation.area,
                countryHasCities: hasCities,
            }));
        }
    }, [countries, receiverGeolocation, setState])
    
    const setName = (value) => {
        setState((prev) => ({ ...prev, "receiver-name": value }));
        setChoosedFromSaved(false);

        let validationResult =  validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value) || 
                                validators.HasOnlyLettersAndSpaces(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "receiver-name": t("errors.receiver_name.only_english_letters"),
            }));

            return
        }

        validationResult = validators.ValidateLength(value, 2)
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "receiver-name": t("errors.receiver_name.min_2")
            }));

            return
        }

        setErrors((prev) => ({
            ...prev,
            "receiver-name": "",
        }));
    };

    const setReceiverCompany = (value) => {
        setState((prev) => ({ ...prev, "receiver-company": value }));
        setChoosedFromSaved(false);

        if (validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value)) {
            setErrors((prev) => ({
                ...prev,
                "receiver-company": t("errors.receiver_company.only_english_letters")
            }));
            return
        }

        if (value.length > 250) {
            setErrors((prev) => ({
                ...prev,
                "receiver-company": t("errors.receiver_company.max_250")
            }));
            return
        }

        setErrors((prev) => ({
            ...prev,
            "receiver-company": ""
        }));
    };

    const setAddress = (value) => {
        setState((prev) => ({ ...prev, "receiver-address": value }));
        setChoosedFromSaved(false);

        let validationResult = interpretReceiverAddressError(
            validators.ValidateReceiverAddress(value),
        );
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "receiver-address": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "receiver-address": "",
            }));
        }
    };

    const setPostalIndex = (value) => {
        setChoosedFromSaved(false);
        setState((prev) => ({ ...prev, "receiver-postal-index": value }));
    }

    const setPhoneNumber = (value) => {
        setState((prev) => ({ ...prev, "receiver-phone-number": value }));
        setChoosedFromSaved(false);

        let validationResult = validators.ValidatePhone(value, 7);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "receiver-phone-number": t("errors.phone.invalid_format")
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "receiver-phone-number": "",
            }));
        }
    };

    const setEmail = (value) => {
        setState((prev) => ({ ...prev, "receiver-email": value }));
        setChoosedFromSaved(false);

        let validationResult = validators.ValidateEmail(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "receiver-email": t(interpretEmailError(validationResult)),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "receiver-email": "",
            }));
        }
    };


    useEffect(() => {
        if (receiverGeoFromSelector) {
            setReceiverGeolocation(receiverGeoFromSelector);
        }
    }, [receiverGeoFromSelector, setReceiverGeolocation]);

    useEffect(() => {
        if (receiverGeoForChooseReceiver) {
            setReceiverGeolocation(receiverGeoForChooseReceiver);
        }
    }, [receiverGeoForChooseReceiver, setReceiverGeolocation]);

    //TODO: move to separate file
    const handleSaveReceiverButtonClick = () => {
        let res = validateReceiver(state) ?? []

        if(state.countryHasCities && !state["receiver-city"]) {
            res.push(t("shipments.create_shipment.receiver.select_city.errors.required"))
        }
        
        res.forEach(error => {
            dispatch(pushAlert({
                type: 'danger',
                message: t(error),
                delay: 2000,
            }))
        })

        if(res.length > 0) {
            return
        }
    

        const receiver = {
            name: state["receiver-name"],
            company: state["receiver-company"],
            address: state["receiver-address"],
            "postal-index": state["receiver-postal-index"],
            "phone-number": state["receiver-phone-number"],
            email: state["receiver-email"],
            country: state["receiver-country"],
            city: state["receiver-city"],
            area: state["receiver-area"],
            district: state["receiver-district"],
        };

        dispatch(createSavedReceiver({ data: receiver }))
    }

    useEffect(() => {
        if (creatingSavedReceiverStatus === "fulfilled") {
            setHaveSavedCurrentReceiver(true);
            dispatch(pushAlert({
                message: t("shipments.create_shipment.saving_receiver.success_message"),
                type: "success",
                delay: 2000,
            }))
            dispatch(setCreatingSavedReceiverStatus(null));
            dispatch(setCreatingSavedReceiverError(null));
        }
    }, [creatingSavedReceiverStatus, dispatch, t])

    //TODO: handle correctly error
    useEffect(() => {
        if (creatingSavedReceiverError) {
            dispatch(pushAlert({
                message: t(creatingSavedReceiverError),
                type: "danger",
                delay: 2000,
            }))
            dispatch(setCreatingSavedReceiverStatus(null));
            dispatch(setCreatingSavedReceiverError(null));
        }
    }, [creatingSavedReceiverError, dispatch])

    return (
        <>
            <header className="text-2xl text-left text-emerald-600 mb-5">
                {(t("shipments.create_shipment.receiver.title"))}
            </header>
            {
                isChoosingFromSaved && (<ReceiversList
                    goBack={() => setIsChoosingFromSaved(false)}
                    setChoosedFromSaved={setChoosedFromSaved}
                    setName={setName}
                    setReceiverCompany={setReceiverCompany}
                    setAddress={setAddress}
                    setPostalIndex={setPostalIndex}
                    setPhoneNumber={setPhoneNumber}
                    setEmail={setEmail}
                    setReceiverGeolocation={setReceiverGeoForChooseReceiver}
                />)
            }
            {!isChoosingFromSaved && (
                <>
                    <main className="text-left flex flex-col gap-4">

                        <Button
                            variant="contained"
                            sx={{
                                color: "white",
                                bgcolor: "#059669",
                                fontSize: "0.5rem",
                                maxWidth: 400,
                                ":hover": {
                                    bgcolor: "#047857",
                                },
                            }}
                            onClick={() => setIsChoosingFromSaved(true)}
                        >
                            {(t("shipments.create_shipment.receiver.select_from_saved"))}
                        </Button>
                        {/* RECEIVER NAME */}
                        <div>
                            <input
                                className={`${style.input} ${style.standard}`}
                                type="text"
                                placeholder={(t("shipments.create_shipment.receiver.receiver_name.placeholder"))}
                                onChange={(e) => setName(e.target.value)}
                                value={state["receiver-name"]}
                            />
                            {errors["receiver-name"] && (
                                <div className={style.error}>
                                    {errors["receiver-name"]}
                                </div>
                            )}
                        </div>
                        {/* COMPANY NAME */}
                        {
                            (isDocumentsPackage(state["package-type"]) || isB2BPackage(state["package-type"])) &&
                            <div>
                                <input
                                    className={`${style.input} ${style.standard}`}
                                    type="text"
                                    placeholder={
                                        t("shipments.create_shipment.receiver.company.placeholder") + "(" + t("global.optional") + ")"
                                    }
                                    onChange={(e) => setReceiverCompany(e.target.value)}
                                    value={state["receiver-company"]}
                                />
                                {errors["receiver-company"] && (
                                    <div className={style.error}>
                                        {errors["receiver-company"]}
                                    </div>
                                )}
                            </div>
                        }
                        {/* EMAIL */}
                        <div>
                            <input
                                className={`${style.input} ${style.standard}`}
                                type="text"
                                placeholder={
                                    t("shipments.create_shipment.receiver.email.placeholder")
                                }
                                onChange={(e) => setEmail(e.target.value)}
                                value={state["receiver-email"]}
                            />
                            {errors["receiver-email"] && (
                                <div className={style.error}>
                                    {errors["receiver-email"]}
                                </div>
                            )}
                        </div>
                        {/* PHONE NUMBER */}
                        <div className="grid grid-cols-12">
                            <span
                                className="col-span-12 text-gray-600"
                            >
                                {t("shipments.create_shipment.receiver.phone.name")}
                            </span>
                            <PhoneInput
                                value={state["receiver-phone-number"]}
                                onChange={(e) => setPhoneNumber(e)}
                                country={"ru"}
                                inputClass={`${style.input} ${style.standard}`}
                                specialLabel=""
                                dropdownClass="hidden"
                                dropdownStyle={{ display: "none" }}
                                className="col-span-12"
                            />
                        </div>
                        {/* LOCATION */}
                        <div>
                            <SelectReceiverCity receiverGeolocation={receiverGeolocation} setReceiverGeolocation={setReceiverGeolocation} />
                            {!receiverGeolocation.city && state.countryHasCities && (
                                <div className={style.error}>
                                    {t("shipments.create_shipment.receiver.select_city.errors.required")}
                                </div>
                            )}
                        </div>
                        {/* ADDRESS */}
                        <div>
                            <input
                                className={`${style.input} ${style.standard}`}
                                type="text"
                                placeholder={t("shipments.create_shipment.receiver.address.placeholder")}
                                onChange={(e) => setAddress(e.target.value)}
                                value={state["receiver-address"]}
                            />
                            {errors["receiver-address"] && (
                                <div className={style.error}>
                                    {errors["receiver-address"]}
                                </div>
                            )}
                        </div>
                        {/* POSTAL INDEX */}
                        <div>
                            <input
                                className={`${style.input} ${style.standard}`}
                                type="text"
                                placeholder={t("shipments.create_shipment.receiver.postal_index.placeholder")}
                                onChange={(e) => setPostalIndex(e.target.value)}
                                value={state["receiver-postal-index"]}
                            />
                        </div>

                        {!haveSavedCurrentReceiver && !choosedFromState && <Button
                            variant="contained"
                            sx={{
                                color: "white",
                                bgcolor: "#059669",
                                fontSize: "0.5rem",
                                maxWidth: 400,
                                ":hover": {
                                    bgcolor: "#047857",
                                },
                            }}
                            onClick={handleSaveReceiverButtonClick}
                        >
                            {t("shipments.create_shipment.receiver.save_receiver_button")}
                        </Button>}
                    </main>
                </>
            )}
        </>
    );
};

export default FirstPage;
